import { useSelector } from 'react-redux';
import { promotionKeys } from 'self-service-api/constants/Promotions';
import { allEligibleDiscountsSelector } from '../selectors/PromotionSelectors';
export default function () {
  const eligibleDiscounts = useSelector(allEligibleDiscountsSelector);
  const eligibleForHsfxDiscount = [promotionKeys.HSFS_SEED, promotionKeys.HSFS_SERIES_A, promotionKeys.STRATEGIC_PARTNERSHIP, promotionKeys.HSFX_BOOTSTRAP, promotionKeys.HSFX_ENTREPRENEUR].reduce((acc, hsfxDiscount) => acc || eligibleDiscounts.includes(hsfxDiscount), false);
  return eligibleForHsfxDiscount;
}